import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue'
import store from '../store/store.js'
import CarbonImpactEstimatorView from "@/views/Architect/CarbonImpactEstimator/CarbonImpactEstimatorView.vue";
import MaterialSelectionView from "@/views/Architect/MaterialSelection/MaterialSelectionView.vue";
import ArchitectDashboardView from "@/views/Architect/ArchitectDashboardView.vue";
import PanelConfigurationView from '@/views/Manufacturer/PanelConfiguration/PanelConfigurationView.vue';
import ProjectInformationView from "@/views/Architect/ProjectInformation/ProjectInformationView.vue";
import ArchitectComingSoonView from '@/views/Architect/AcousticPartitionAndSeparation/ComingSoonView.vue';
import CommentsView from '@/views/Architect/Comments/CommentsView.vue';
import ArchitectSettingsView from '@/views/Architect/Settings/SettingsView.vue';

const ManufacturerDashboardView = () => import('@/views/Manufacturer/DashboardView.vue');
const ManufacturerProfileView = () => import('@/views/Manufacturer/Profile/ProfileView.vue');
const ManufacturerFacilityPrequalificationView = () => import('@/views/Manufacturer/FacilityPrequalification/LocationsView.vue');
const ManufacturerFacilitiesView = () => import('@/views/Manufacturer/FacilityPrequalification/FacilitiesView.vue');
const AdminPortalView = () => import('@/views/Admin/AdminPortalView.vue');
const CarbonManagerPortalView = () => import('@/views/CarbonManager/CarbonManagerPortalView.vue');
const CostManagerDashboardView = () => import('@/views/CostManager/DashboardView.vue');
const StructureDashboardView = () => import('@/views/Structure/StructureDashboardView.vue');
const ContreventementView = () => import('@/views/Structure/Contreventement/ContreventementView.vue');
const ProjectView = () => import('@/views/Common/ProjectView.vue');


const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView
  },
  {
    path: '/architect',
    name: 'ArchitectProject',
    component: ProjectView
  },
  {
    path: '/architect/dashboard',
    name: 'ArchitectDashboard',
    component: ArchitectDashboardView
  },
  {
    path: '/architect/carbonimpactestimator',
    name: 'CarbonImpactEstimatorView',
    component: CarbonImpactEstimatorView
  },
  {
    path: '/architect/projectinformation',
    name: 'ProjectInformationView',
    component: ProjectInformationView
  },
  {
    path: '/architect/materialselection',
    name: 'MaterialSelectionView',
    component: MaterialSelectionView
  },
  {
    path: '/architect/acousticpartitionandseparation',
    name: 'AcousticPartitionAndSeparationView',
    component: ArchitectComingSoonView
  },
  {
    path: '/architect/settings',
    name: 'ArchitectSettingsView',
    component: ArchitectSettingsView
  },
  {
    path: '/architect/comments',
    name: 'CommentsView',
    component: CommentsView
  },
  {
    path: '/architect/managecolaborators',
    name: 'ManageCollaboratorsView',
    component: ArchitectComingSoonView
  },
  {
    path: '/manufacturer/panelconfiguration',
    name: 'PanelConfigurationView',
    component: PanelConfigurationView
  },
  {
    path: '/manufacturer',
    name: 'ManufacturerDashboard',
    component: ManufacturerDashboardView,
    alias: [
      '/manufacturer/product-standardization',
      '/manufacturer/budget'
    ]
  },
  {
    path: '/manufacturer/profile',
    name: 'ManufacturerProfile',
    component: ManufacturerProfileView
  },
  {
    path: '/manufacturer/facility-prequalification',
    name: 'ManufacturerFacilityPrequalification',
    component: ManufacturerFacilityPrequalificationView
  },
  {
    path: '/manufacturer/locations/:locationId/facilities',
    name: 'ManufacturerFacilities',
    component: ManufacturerFacilitiesView,
    props: true
  },
  {
    path: '/manufacturer/panelconfiguration',
    name: 'PanelConfigurationView',
    component: PanelConfigurationView,
    alias: ['/architect/panelcountestimator/panelconfiguration']
  },
  {
    path: '/admin',
    name: 'AdminPortal',
    component: AdminPortalView
  },
  {
    path: '/carbon-manager',
    name: 'CarbonManagerPortal',
    component: CarbonManagerPortalView
  },
  {
    path: '/cost-manager',
    name: 'CostManagerPortal',
    component: CostManagerDashboardView
  },
  {
    path: '/structure',
    name: 'StructureProject',
    component: ProjectView
  },
  {
    path: '/structure/dashboard',
    name: 'StructureDashboard',
    component: StructureDashboardView
  },
  {
    path: '/structure/bracing',
    name: 'Contreventement',
    component: ContreventementView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: ArchitectComingSoonView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
    };
  }
});

const rolePortals = {
  architect: {
    matches: (to) => to.path.startsWith('/architect'),
    redirect: { path: '/architect' }
  },
  manufacturer: {
    matches: (to) => to.path.startsWith('/manufacturer'),
    redirect: { path: '/manufacturer' }
  },
  admin: {
    matches: (to) => to.path.startsWith('/admin'),
    redirect: { path: '/admin' }
  },
  carbonmanager: {
    matches: (to) => to.path.startsWith('/carbon-manager'),
    redirect: { path: '/carbon-manager' }
  },
  costmanager: {
    matches: (to) => to.path.startsWith('/cost-manager'),
    redirect: { path: '/cost-manager' }
  },
  structure: {
    matches: (to) => to.path.startsWith('/structure'),
    redirect: { path: '/structure' }
  }
};

const publicRoutes = new Set(['HomeView']);

const redirectToPortal = (portalConfig, to, next) => {
  if (!portalConfig || !portalConfig.redirect) {
    return false;
  }

  const redirectTarget = portalConfig.redirect;

  if (typeof redirectTarget === 'string') {
    if (redirectTarget === to.fullPath || redirectTarget === to.path) {
      next();
      return true;
    }
    next(redirectTarget);
    return true;
  }

  if (redirectTarget.path && redirectTarget.path === to.path && !redirectTarget.query && !redirectTarget.hash) {
    next();
    return true;
  }

  next(redirectTarget);
  return true;
};

const setRouteLoadingState = (isLoading) => {
  if (typeof document === 'undefined') {
    return;
  }
  if (isLoading) {
    document.body.setAttribute('aria-busy', 'true');
  } else {
    document.body.removeAttribute('aria-busy');
  }
};

const resolvePortalConfig = (role) => {
  if (!role) {
    return null;
  }
  return rolePortals[role.toLowerCase()] ?? null;
};

router.beforeEach(async (to, from, next) => {
  if (to.query.access_code) {
    try {
      await store.dispatch('exchangeAccessCode', to.query.access_code)
    } catch (err) {
      console.warn("exchange failed", err);
    }
    return next("/")
  }

  const isPublicRoute = publicRoutes.has(to.name);

  let loaderActivated = false;
  try {
    let user = store.state.user;
    if (!user || !user.role) {
      if (!isPublicRoute) {
        setRouteLoadingState(true);
        loaderActivated = true;
      }
      await store.dispatch("getUser");
      user = store.state.user;
    }

    if (!user || !user.role) {
      if (isPublicRoute) {
        return next();
      }
      console.warn('Unable to determine user role. Redirecting to home.');
      return next('/');
    }

    const portalConfig = resolvePortalConfig(user.role);

    if (!portalConfig) {
      console.warn(`Unknown role "${user.role}" encountered. Redirecting to home.`);
      if (isPublicRoute) {
        return next('/');
      }
      return next('/');
    }

    if (isPublicRoute) {
      if (redirectToPortal(portalConfig, to, next)) {
        return;
      }
      return next();
    }

    if (!portalConfig.matches(to)) {
      if (redirectToPortal(portalConfig, to, next)) {
        return;
      }
    }

    return next();
  } catch (err) {
    console.error('Error while evaluating navigation guard:', err);
    if (isPublicRoute) {
      return next();
    }
    return next("/")
  } finally {
    if (loaderActivated) {
      setRouteLoadingState(false);
    }
  }
})

export default router